
<template>
	<page>
		<module>
			<view-list
				ref="view"
				work-type="33"
				selector
			>
				<template #search>
					<m-search ref="search">
						<m-search-item label="背贴码">
							<m-code-batch-input name="produce_codes" field-name="背贴码" placeholder="请输入背贴码，支持批量"></m-code-batch-input>
						</m-search-item>
						<m-search-item label="IMEI">
							<m-code-batch-input name="imeis" field-name="IMEI" placeholder="请输入IMEI，支持批量"></m-code-batch-input>
						</m-search-item>
						<m-search-item label="关键字">
							<c-input name="keyword" placeholder="售后单号/订单号"></c-input>
						</m-search-item>
						<m-search-item label="申请人">
							<c-input name="applicant" placeholder="姓名/手机号"></c-input>
						</m-search-item>
						<m-search-item label="退货快递">
							<c-input name="return_express" placeholder="快递公司/快递单号"></c-input>
						</m-search-item>
						<m-search-item label="申请时间" colspan="2">
							<c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
						</m-search-item>
					</m-search>
				</template>

				<template #refund_info="{data}">
					<span v-if="!Number(data.refund_amount)">-</span>
					<div v-else class="m-product-info">
						<p style="color: #e53e3e;">{{formatPrice(data.refund_amount)}}</p>
						<p class="m-product-info-code">{{data.refund_date || '-'}}</p>
					</div>
				</template>

				<template #product_info="{data}">
					<m-product-info :name="getProductText(data)" :level="data.level_type" :code="data.produce_code" :imei="data.produce_imei"></m-product-info>
				</template>



                <template #after_sale_type="{data}">
                    <c-state async dict="SALE_AFTER_SALE_TYPE" :value="data.after_sale_type"></c-state>
                </template>

				<template #after_sale_state="{data}">
					<c-state async dict="SALE_AFTER_SALE_STATE" :value="data.after_sale_state"></c-state>
				</template>

				<template #order_info="{data}">
					<div class="m-product-info">
						<p>{{data.order_no || '-'}}</p>
						<p class="m-product-info-code">三方订单号：{{data.third_party_order_no || data.order_no || '-'}}</p>
					</div>
				</template>

				<template #after_sale_amount="{data}">
					<span style="color: #e53e3e;">{{formatPrice(data.after_sale_amount)}}</span>
				</template>

				<template #applicant_info="{data}">
					<div class="m-product-info">
						<p v-if="data.applicant_name">{{data.applicant_name}}</p>
						<p v-if="data.applicant_phone" class="m-product-info-code">{{data.applicant_phone}}</p>
						<p v-if="!data.applicant_name && !data.applicant_phone">-</p>
					</div>
				</template>

				<template #return_express_info="{data}">
					<div class="m-product-info">
						<p v-if="data.return_express_company">{{data.return_express_company}}</p>
						<p v-if="data.return_express_no" class="m-product-info-code">{{data.return_express_no}}</p>
						<p v-if="!data.return_express_company && !data.return_express_no">-</p>
					</div>
				</template>

				<template #audit_user_id="{data}">
					{{data.audit_user_realname || '-'}}
				</template>
                <template #refund_user_id="{data}">
                    {{data.refund_user_realname || '-'}}
                </template>

				<c-table-column
					type="button"
					label="操作"
					width="160"
					button-limit="6"
				>
					<template #default="{data}">
						<c-table-button v-if="auth('b_online_aftersales_order_query')" icon="tf-detail" @click="viewDetail(data)">查看</c-table-button>
						<!--行级按钮可见性由服务端按渠道归属+状态+类型统一下发（data.buttons），端内只保留 auth 权限点位判断-->
						<c-table-button v-if="auth('b_online_aftersales_order_audit') && (data.buttons?.audit?.visible || data.buttons?.reject?.visible) && data.after_sale_state == 1" icon="tf-resolve" @click="viewDetail(data)">审批</c-table-button>
						<c-table-button v-if="auth('b_online_aftersales_order_confirm_return') && data.buttons?.confirm_return?.visible" icon="tf-accept" @click="confirmReturn(data)">确认收货</c-table-button>
						<c-table-button v-if="auth('b_online_aftersales_order_refund') && data.after_sale_state == 4" icon="tf-accept" @click="confirmRefund(data)">确认退款</c-table-button>
					</template>
				</c-table-column>
			</view-list>
		</module>
	</page>
</template>

<script>
	export default {
		methods: {
			/*********格式化价格**********/
			formatPrice(price) {
				if (price === null || price === undefined || price === '') return '-';
				return '¥' + parseFloat(price).toFixed(2);
			},

			/*********获取产品信息文字**********/
			getProductText(data) {
				var parts = [];
				if (data.brand_name) parts.push(data.brand_name);
				if (data.model_name) parts.push(data.model_name);
				if (data.memory_name) parts.push(data.memory_name);
				if (data.color_name) parts.push(data.color_name);
				return parts.join(' ') || '-';
			},

			/*********查看售后详情**********/
			viewDetail(data) {
				this.globalDialog('onlineAftersaleDetail', {
					data: {
						afterSaleId: data.after_sale_id,
						productId: data.id,
						orderType: 2
					}
				}, () => {
					this.$refs.view.update();
				});
			},


			/*********确认退货收货（后端按售后主单ID操作，列表行是商品明细维度，必须传 after_sale_id）**********/
			confirmReturn(data) {
				this.$confirm({
					message: '确认已收到售后单【' + data.after_sale_no + '】的退货商品吗？',
					buttonName: '确定',
					cancelButton: true,
					resolve: () => {
						this.request({
							url: '/aftersale/confirm_return_online',
							data: {
								id: data.after_sale_id
							},
							loading: true,
							success: (data, msg) => {
								this.$message({message: msg || '确认成功', type: 'success'});
								this.$refs.view.update();
							}
						});
					}
				});
			},

			/*********确认退款（退货退款=待商家退款(4)金额已定；仅退款=无审核环节待审核(1)直接退款通过，
			 * 按售后单登记金额提交；主单ID同上）**********/
			confirmRefund(data) {
				this.$confirm({
					message: '确认对售后单【' + data.after_sale_no + '】执行退款 ' + this.formatPrice(data.after_sale_amount) + ' 吗？',
					buttonName: '确定',
					cancelButton: true,
					resolve: () => {
						var params = {
							id: data.after_sale_id
						};
						//仅退款写接口要求填退款金额，取售后单登记金额
						if (data.after_sale_type == 2) {
							params.refund_amount = data.after_sale_amount;
						}
						this.request({
							url: '/aftersale/refund_online',
							data: params,
							loading: true,
							success: (data, msg) => {
								this.$message({message: msg || '退款成功', type: 'success'});
								this.$refs.view.update();
							}
						});
					}
				});
			},
		}
	}
</script>

<style lang="stylus" scoped>
	.m-product-info {
		line-height: 24px;
		font-size: 13px;
		color: #333;

		.m-product-info-name {
			display: flex;
			align-items: center;
			gap: 4px;
		}

		.m-product-info-code {
			color: #999;
			font-size: 12px;
		}
	}
</style>
